const React = require('react');
const map = require('mn-utils/map');
const find = require('mn-utils/find');
const {
  LINK_DASHBOARD,
  LINK_TRANSACTIONS,
  LINK_PAYMENT_LINK,
  LINK_MPOS_CREDENTIAL,
  LINK_MPOS_TERMINALS,
  LINK_MPOS_TERMINALS_ORDER,
  LINK_WIDGETS,
  LINK_WIDGETS_NEW,
  LINK_SETTINGS,
  LINK_HELP,

  // LINK_ADMIN_TESTING_WALLET_QR,

  NAV_LINKS_OF_ADMIN, NAV_LINKS_OF_AUDITOR, LINK_REFERRAL_ADMIN,
} = require('../../../../constants/links');
const {
  Link,
  path$,
} = require('../../../../router');
const withState = require('../../../../utils/withState');
const {
  accountType$,
} = require('../../../../emitters/account');
const Ripple = require('../../../dumb/Ripple');

const DashboardDataItem = {name: 'Dashboard', link: LINK_DASHBOARD};
const TerminalsDataItem = {name: 'mPOS Terminals', link: LINK_MPOS_TERMINALS};
const SettingsDataItem = {name: 'Settings', link: LINK_SETTINGS};
const HelpDataItem = {name: 'Help', link: LINK_HELP};

const NAV_LINKS = [
  DashboardDataItem,
  {name: 'Transactions', link: LINK_TRANSACTIONS},
  {name: 'Pay by link', link: LINK_PAYMENT_LINK},
  {
    ...TerminalsDataItem,
    childs: [
      {name: 'Order terminals', link: LINK_MPOS_TERMINALS_ORDER},
      {name: 'Terminals', link: LINK_MPOS_TERMINALS, strict: 1},
      {name: 'mPOS Credential', link: LINK_MPOS_CREDENTIAL},
    ],
  },
  {
    name: 'Widgets',
    link: LINK_WIDGETS,
    childs: [
      {name: 'Add Widget', link: LINK_WIDGETS_NEW},
      {name: 'Widgets', link: LINK_WIDGETS, strict: 1},
    ],
  },
  SettingsDataItem,
  HelpDataItem,
];
const NAV_LINKS_OPERATORS = [
  DashboardDataItem,
  TerminalsDataItem,
  SettingsDataItem,
  HelpDataItem,
];

const NAV_MAP = {
  merchant: NAV_LINKS,
  operator: NAV_LINKS_OPERATORS,
  admin: NAV_LINKS_OF_ADMIN,
  auditor: NAV_LINKS_OF_AUDITOR
};

function Indicator(props) {
  return (
    <div className={'w50 hmin1 ' + (props.className || '')}>
      <div className="dn500 o0 (o100|bxsh20y4c33A4E3)<2.active sq8 bg33A4E3
        r ovH mhA"/>
    </div>
  );
}

module.exports = withState(() => {
  return (state) => {
    const {
      path,
    } = state;

    function isActive(item) {
      const link = item.link;
      return item.strict
        ? link === path
        : path.startsWith(link);
    }

    return (
      <div className="mh-15 pt10 pb20">
        {map(NAV_MAP[state.accountType], (item) => {
          const {
            name,
            disabled,
          } = item;
          const childs = item.childs || [];
          const active = isActive(item) || find(childs, isActive);
          return (
            <div
              key={name}
              className="mb8 rlv"
            >
              <Ripple
                component={disabled || active ? 'div' : Link}
                className={`layoutRow fhaS fvaC rlv h40 r4 f18 lh tdN fw4 dn ovH
                  ff$2 usN c717478 cF.active o50.disabled `
                  + (active ? ' active' : '')}
                disabled={disabled}
                href={disabled ? null : item.link}
                activeAsParent
              >
                <Indicator/>
                <div>{name}</div>
              </Ripple>
              {
                childs.length ? (
                  <div className={'dN dB.active' + (active ? ' active' : '')}>
                    {map(childs, (item) => {
                      const {
                        name,
                        disabled,
                      } = item;
                      const active = isActive(item);
                      return (
                        <Ripple
                          key={name}
                          component={disabled ? 'div' : Link}
                          className={`layoutRow fhaS fvaC c7A7D83 rlv h40 r4
                            f16 lh tdN fw4 dn ovH usN c717478 (cF|fw5).active
                            o50.disabled ` + (active ? ' active' : '')}
                          disabled={disabled}
                          href={disabled ? null : item.link}
                          activeAsParent
                        >
                          <Indicator className="ml15"/>
                          <div>{name}</div>
                        </Ripple>
                      );
                    })}
                  </div>
                ) : null
              }
            </div>
          );
        }, [])}
      </div>
    );
  };
}, {
  path: path$,
  accountType: accountType$,
});
